import { useState } from "react";
import { useSearch } from "@tanstack/react-router";

// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { ReturnStepper } from "./ReturnStepper";
import { ReturnInvoice } from "./ReturnInvoice";
import { ReturnDetails } from "./ReturnDetails";
import { ReturnSubmit } from "./ReturnSubmit";
import { ReturnComplete } from "./ReturnComplete";

// Material-ui imports
import Box from "@mui/material/Box";

export function ReturnOrderCreate() {
  const { invoice: invoiceNo } = useSearch({ strict: false });

  const [activeStep, setActiveStep] = useState(0);
  const [returnData, setReturnData] = useState({});
  const [returnDataOriginal, setReturnDataOriginal] = useState({});

  return (
    <>
      <Box>
        <GenericListHeader heading={`New Return`} />
        <ReturnStepper activeStep={activeStep} setActiveStep={setActiveStep} />
        {activeStep === 0 && (
          <ReturnInvoice
            invoiceNo={invoiceNo}
            returnData={returnData}
            setReturnData={setReturnData}
            setReturnDataOriginal={setReturnDataOriginal}
            setActiveStep={setActiveStep}
          />
        )}
        {activeStep === 1 && (
          <ReturnDetails
            returnData={returnData}
            setReturnData={setReturnData}
            returnDataOriginal={returnDataOriginal}
            setActiveStep={setActiveStep}
          />
        )}
        {activeStep === 2 && (
          <ReturnSubmit
            returnData={returnData}
            setReturnData={setReturnData}
            setActiveStep={setActiveStep}
          />
        )}
        {activeStep > 2 && <ReturnComplete returnData={returnData} />}
      </Box>
    </>
  );
}
